class ImageModalController {
  constructor(
    $scope,
    $uibModalInstance,
    image
  ) {
    "ngInject";
    this.$scope            = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this._image            = image;
  }

  get image() {
    return this._image;
  }

  get imageUrl() {
    return this._image && this._image.url;
  }

  get imageName() {
    return this._image && this._image.name;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default ImageModalController;
